import { formatRupeeLabel } from '../../../../../display-values/lumpsumPlanAmount'
import type { LumpsumRebalanceInvalidatedRecommendation } from '../../../../api/rebalance.types'
import { LumpsumRecommendationActionType } from '../../../../api/common.types'
import type { PlanInvalidatedSubsectionKey } from '../../../../api/types'
import { PlansFundCard } from '../../../lumpsum-ui-components/PlansFundCard'
import { buildRebalanceBuyInsights } from './RebalanceBuyFundCard'
import { buildRebalanceSellInsights } from './RebalanceSellFundCard'
import { buildRebalanceUnderReviewInsights } from './RebalanceUnderReviewFundCard'

type RebalanceInvalidatedFundCardProps = {
  recommendation: LumpsumRebalanceInvalidatedRecommendation
  subsectionKey: PlanInvalidatedSubsectionKey
  showBottomDivider?: boolean
}

export function RebalanceInvalidatedFundCard({
  recommendation,
  subsectionKey,
  showBottomDivider = true
}: RebalanceInvalidatedFundCardProps) {
  const isin = recommendation?.isin ?? ''
  const currentValue = recommendation?.currentValue ?? 0

  return (
    <PlansFundCard
      fund={{
        isin,
        logoUrl: recommendation?.mfLogoUrl ?? '',
        title: recommendation?.fundName ?? '',
        fundNature: recommendation?.fundNature ?? '',
        category: recommendation?.fundCategory ?? '',
        purchaseMode: recommendation?.purchaseMode ?? ''
      }}
      topRight={
        <div className="text-right shrink-0 -mt-[1px] text-[13px] font-[500] text-[#232323]">
          {formatRupeeLabel({ rawAmount: currentValue })}
        </div>
      }
      status={{
        rank: recommendation?.powerRank ?? 0,
        rating: recommendation?.powerRating ?? ''
      }}
      recommendationStatus={recommendation?.recommendationStatus}
      recommendationStatusDisplayText={recommendation?.recommendationStatusDisplayText}
      insights={getRebalanceInvalidatedInsights(recommendation, subsectionKey)}
      supportingText={recommendation?.recommendationStatusDisplayText ?? ''}
      showBottomDivider={showBottomDivider}
    />
  )
}

function getRebalanceInvalidatedInsights(
  recommendation: LumpsumRebalanceInvalidatedRecommendation,
  subsectionKey: PlanInvalidatedSubsectionKey
) {
  if (subsectionKey === 'buy') {
    return buildRebalanceBuyInsights(recommendation)
  }

  if (subsectionKey === 'sell') {
    return buildRebalanceSellInsights(recommendation)
  }

  if (subsectionKey === 'underReview') {
    return buildRebalanceUnderReviewInsights(recommendation)
  }

  if (recommendation?.actionType === LumpsumRecommendationActionType.BUY) {
    return buildRebalanceBuyInsights(recommendation)
  }

  return buildRebalanceSellInsights(recommendation)
}
